import { render, staticRenderFns } from "./RefineComponent.vue?vue&type=template&id=66ed533c&scoped=true"
import script from "./RefineComponent.vue?vue&type=script&lang=js"
export * from "./RefineComponent.vue?vue&type=script&lang=js"
import style0 from "./RefineComponent.vue?vue&type=style&index=0&id=66ed533c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ed533c",
  null
  
)

export default component.exports